var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Page",
    { attrs: { title: _vm.title } },
    [
      _c("div", { staticClass: "header-titile-all" }, [
        _c("div", { staticClass: "searchTitle-top-header flex" }, [
          _c("div", { staticClass: "searchTitle-top" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.PageShow == false,
                    expression: "PageShow==false"
                  }
                ],
                staticClass: "picker-alls",
                on: {
                  click: function($event) {
                    return _vm.pickerClient(1)
                  }
                }
              },
              [
                _vm._v(_vm._s(_vm.queryFlagText) + "\n          "),
                _c("div", { staticClass: "triangle_border_down" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex input-search-flex",
                style: { flex: _vm.PageShow == true ? ".95" : "" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.queryParam,
                      expression: "queryParam"
                    }
                  ],
                  ref: "inputText",
                  staticClass: "search_input",
                  attrs: { type: "text", placeholder: "客户姓名/手机号码" },
                  domProps: { value: _vm.queryParam },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.submitInput(_vm.queryParam)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.queryParam = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "search-img",
                  attrs: { src: require("@/assets/img/search.png"), alt: "" },
                  on: {
                    click: function($event) {
                      return _vm.searchInput(_vm.queryParam)
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filtrate-list flex",
              on: { click: _vm.searchFilter }
            },
            [
              _c("img", {
                staticClass: "filtrate-img",
                attrs: { src: require("@/assets/img/filtrate.png"), alt: "" }
              }),
              _vm._v(" "),
              _c("div", [_vm._v("筛选")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex flexJ" }, [
          _c(
            "div",
            { staticClass: "filtrate-lists-areaList" },
            [
              _c("van-checkbox", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.PageShow == true,
                    expression: "PageShow==true"
                  }
                ],
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function(props) {
                      return _c("img", {
                        staticClass: "radioImg",
                        attrs: {
                          src: props.checked ? _vm.Icon[0] : _vm.Icon[1]
                        },
                        on: {
                          click: function($event) {
                            return _vm.clickCheck(_vm.checked)
                          }
                        }
                      })
                    }
                  }
                ]),
                model: {
                  value: _vm.checked,
                  callback: function($$v) {
                    _vm.checked = $$v
                  },
                  expression: "checked"
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.filtrateList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "flex filtrate-lists-area-item",
                    on: {
                      click: function($event) {
                        return _vm.order4Page(item)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { class: item.status != 0 ? "activeTitle" : "" },
                      [_vm._v(_vm._s(item.name))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "triangle flexC" }, [
                      item.status == 0 || item.status == 1
                        ? _c("div", {
                            staticClass: "triangle_border_up",
                            class:
                              item.status == 1 || item.status == -1
                                ? "activeTitles"
                                : ""
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.status == 0 || item.status == -1
                        ? _c("div", {
                            staticClass: "triangle_border_down",
                            class:
                              item.status == 1 || item.status == -1
                                ? "activeTitles"
                                : ""
                          })
                        : _vm._e()
                    ])
                  ]
                )
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "scrollView", staticClass: "scroll-view" },
        [
          _c(
            "van-list",
            {
              ref: "page",
              attrs: {
                loading: false,
                finished: _vm.finished,
                "immediate-check": false,
                "finished-text": "没有更多了"
              },
              on: { load: _vm.onLoad },
              model: {
                value: _vm.loading,
                callback: function($$v) {
                  _vm.loading = $$v
                },
                expression: "loading"
              }
            },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "scroll-view-list-item" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.PageShow == true,
                          expression: "PageShow==true"
                        }
                      ],
                      staticClass: "checkbox-list"
                    },
                    [
                      _c("van-checkbox", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function(props) {
                                return _c("img", {
                                  staticClass: "radioImg",
                                  attrs: {
                                    src: props.checked
                                      ? _vm.Icon[0]
                                      : _vm.Icon[1]
                                  }
                                })
                              }
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: item.edit,
                          callback: function($$v) {
                            _vm.$set(item, "edit", $$v)
                          },
                          expression: "item.edit"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "headerImgTop",
                      on: {
                        click: function($event) {
                          return _vm.toClientDetail(item.custId)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "headerImg",
                        attrs: {
                          src: item.headImgUrl
                            ? item.headImgUrl
                            : item.gender == 1
                            ? require("@/assets/WW.png")
                            : require("@/assets/MM.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      item.member == "10"
                        ? _c("img", {
                            staticClass: "vipImg",
                            attrs: {
                              src: require("@/assets/img/v.png"),
                              alt: ""
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.vipLevel
                        ? _c(
                            "div",
                            {
                              staticClass: "VIP-starts",
                              style: "width:" + item.vipLevel * 0.4 + "rem"
                            },
                            _vm._l(item.vipLevel, function(item, index) {
                              return _c("img", {
                                key: index,
                                staticClass: "start",
                                attrs: {
                                  src: require("@/assets/img/vipStar.png"),
                                  alt: "",
                                  srcset: ""
                                }
                              })
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "information-list",
                      on: {
                        click: function($event) {
                          return _vm.toClientDetail(item.custId)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "information-list-item item-lists flex activeFont"
                        },
                        [
                          _vm._v(
                            _vm._s(item.custName || "") + "\n            "
                          ),
                          _c("img", {
                            staticClass: "sexImg",
                            attrs: {
                              src:
                                item.gender == 1
                                  ? require("@/assets/WW1.png")
                                  : item.gender == 0
                                  ? require("@/assets/MM1.png")
                                  : "",
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "information-list-item activeFont item-lists"
                        },
                        [
                          _c("img", {
                            staticClass: "phoneImg",
                            attrs: {
                              src: require("@/assets/img/phones.png"),
                              alt: "",
                              srcset: ""
                            }
                          }),
                          _vm._v("\n            " + _vm._s(item.mobile || ""))
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "information-list-item item-lists activeFonts"
                        },
                        [
                          _vm._v(
                            "预计购买日期: " +
                              _vm._s(
                                item.planDate ? item.planDate.split(" ")[0] : ""
                              )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "information-list-item item-lists activeFonts"
                        },
                        [
                          _vm._v(
                            "最近购买日期: " +
                              _vm._s(
                                item.buyDate ? item.buyDate.split(" ")[0] : ""
                              )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "information-list-item item-lists activeFonts"
                        },
                        [_vm._v("跟进日期: " + _vm._s(item.followDate || ""))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "tool" }, [
                    _vm.PageShow == false &&
                    _vm.showCC == false &&
                    _vm.columnK.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "operation item",
                            on: {
                              click: function($event) {
                                return _vm.shortcut(item.custId)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "phoneImg",
                              attrs: {
                                src: require("@/assets/img/set.png"),
                                alt: "",
                                srcset: ""
                              }
                            }),
                            _vm._v("\n              快捷操作\n              ")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showCC == false &&
                    _vm.PageShow == false &&
                    item.U_UseId != null
                      ? _c(
                          "div",
                          {
                            staticClass: "operation-chat item",
                            on: {
                              click: function($event) {
                                return _vm.openUserProfile(item.U_UseId)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "phoneImg",
                              attrs: {
                                src: require("@/assets/img/chat.png"),
                                alt: "",
                                srcset: ""
                              }
                            }),
                            _vm._v("\n              发起聊天\n          ")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showCC == false &&
                    _vm.PageShow == false &&
                    item.U_UseId != null
                      ? _c(
                          "div",
                          {
                            staticClass: "operation-chat item",
                            on: {
                              click: function($event) {
                                return _vm.openTaskUrl(item.U_UseId)
                              }
                            }
                          },
                          [_vm._v("\n              查看任务\n          ")]
                        )
                      : _vm._e()
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.PageShow == false && _vm.showCC == false,
              expression: "PageShow==false&&showCC==false"
            }
          ],
          class: _vm.hasAddAuth ? "orientation-bottom" : "orientation-bottom-1"
        },
        [
          _c("div", { staticClass: "homePage", on: { click: _vm.home } }, [
            _c("img", {
              staticClass: "homePageImg",
              attrs: { src: require("@/assets/img/homePage.png"), alt: "" }
            })
          ]),
          _vm._v(" "),
          _vm.hasAddAuth
            ? _c("div", { staticClass: "add", on: { click: _vm.addClients } }, [
                _c("img", {
                  staticClass: "addImg",
                  attrs: { src: require("@/assets/img/add.png"), alt: "" }
                })
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          model: {
            value: _vm.addClient,
            callback: function($$v) {
              _vm.addClient = $$v
            },
            expression: "addClient"
          }
        },
        [
          _c("div", { staticClass: "add-model" }, [
            _c("div", { staticClass: "addClientTitle" }, [_vm._v("新增客户")]),
            _vm._v(" "),
            _c("div", { staticClass: "codePhone" }, [
              _c("div", { staticClass: "codeArea" }, [
                _c(
                  "div",
                  {
                    staticClass: "codeAreaInput",
                    on: {
                      click: function($event) {
                        return _vm.pickerClient(2)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.addClientObj["code"]))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-flex" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.addClientObj["phone"],
                      expression: "addClientObj['phone']"
                    }
                  ],
                  attrs: {
                    type: "number",
                    oninput: "if(value.length>30)value=value.slice(0,30)",
                    placeholder: "请输入手机号码"
                  },
                  domProps: { value: _vm.addClientObj["phone"] },
                  on: {
                    blur: function($event) {
                      return _vm.phoneCS(_vm.addClientObj["phone"])
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.addClientObj, "phone", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "client-name" }, [
              _c("div", { staticClass: "client-name-flex" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.addClientObj["name"],
                      expression: "addClientObj['name']"
                    }
                  ],
                  staticClass: "client-name-input",
                  attrs: {
                    type: "text",
                    oninput: "if(value.length>100)value=value.slice(0,100)",
                    placeholder: "请输入客户姓名"
                  },
                  domProps: { value: _vm.addClientObj["name"] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.addClientObj, "name", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "genderRadio-flex" },
              [
                _c(
                  "van-radio-group",
                  {
                    model: {
                      value: _vm.addClientObj["sex"],
                      callback: function($$v) {
                        _vm.$set(_vm.addClientObj, "sex", $$v)
                      },
                      expression: "addClientObj['sex']"
                    }
                  },
                  [
                    _c(
                      "van-radio",
                      {
                        attrs: { name: "1" },
                        scopedSlots: _vm._u([
                          {
                            key: "icon",
                            fn: function(props) {
                              return _c("img", {
                                staticClass: "radioImg",
                                attrs: {
                                  src: props.checked ? _vm.Icon[0] : _vm.Icon[1]
                                }
                              })
                            }
                          }
                        ])
                      },
                      [_vm._v(" 男\n            ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-radio",
                      {
                        attrs: { name: "2" },
                        scopedSlots: _vm._u([
                          {
                            key: "icon",
                            fn: function(props) {
                              return _c("img", {
                                staticClass: "radioImg",
                                attrs: {
                                  src: props.checked ? _vm.Icon[0] : _vm.Icon[1]
                                }
                              })
                            }
                          }
                        ])
                      },
                      [_vm._v(" 女\n            ")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "confirm-cancel" }, [
              _c(
                "div",
                { staticClass: "button-flex-color flex-border-button" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "button-flex-item",
                      on: { click: _vm.addCL }
                    },
                    [_vm._v("取消")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "button-flex-color" }, [
                _c(
                  "div",
                  {
                    staticClass: "button-flex-item button-active",
                    on: { click: _vm.addCF }
                  },
                  [_vm._v("确定")]
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c("van-picker", {
            staticClass: "van-picker-li",
            attrs: {
              "show-toolbar": "",
              title: "",
              columns: _vm.columns,
              "value-key": "name"
            },
            on: { cancel: _vm.onCancel, confirm: _vm.onConfirm }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.showUser,
            callback: function($$v) {
              _vm.showUser = $$v
            },
            expression: "showUser"
          }
        },
        [
          _c("van-picker", {
            staticClass: "van-picker-li",
            attrs: {
              "show-toolbar": "",
              title: "",
              columns: _vm.columnsCode,
              "value-key": "name"
            },
            on: { cancel: _vm.onCancelCode, confirm: _vm.onConfirmCode }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("van-actionsheet", {
        attrs: { actions: _vm.columnK, "cancel-text": "取消" },
        on: { select: _vm.onSelectK, cancel: _vm.onCancelK },
        model: {
          value: _vm.Kshow,
          callback: function($$v) {
            _vm.Kshow = $$v
          },
          expression: "Kshow"
        }
      }),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticStyle: { width: "100%" },
          attrs: { position: "right", overlay: false },
          model: {
            value: _vm.filtersShow,
            callback: function($$v) {
              _vm.filtersShow = $$v
            },
            expression: "filtersShow"
          }
        },
        [_c("Filters")],
        1
      ),
      _vm._v(" "),
      this.$store.state.show == 2
        ? _c(
            "div",
            {
              staticClass: "toAssign",
              style: { bottom: this.$store.state.show == 2 ? "0rem" : "1rem" }
            },
            [
              _c(
                "div",
                { staticClass: "toAssign-button", on: { click: _vm.toAssign } },
                [_vm._v("分派")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "loaded",
          style: { bottom: this.$store.state.show == 2 ? "1.2rem" : "0rem" }
        },
        [
          _vm._v(
            "已加载 " + _vm._s(this.list.length) + "/" + _vm._s(_vm.totalRow)
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce8409a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce8409a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/client.vue
// module id = null
// module chunks = 